export const SEARCH_PARAMS = {
  OPEN_CHAT: 'openChat',
  ESCALATE_CHAT: 'escalateChat',
} as const;

export const URL_PATHNAME = {
  VDP: '/vehicle/',
  PURCHASE: '/purchase', // NOTE: entry routing from Carvana home page does not have ending backslash. URL gets changed again after.
  STC: 'sell-my-car',
  SRP: 'cars',
};
